import { render, staticRenderFns } from "./OperatorsForm.vue?vue&type=template&id=c745f1c8&"
import script from "./OperatorsForm.vue?vue&type=script&lang=js&"
export * from "./OperatorsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports